(function(){
	var s = document.createElement('script'),
	e = ! document.body ? document.querySelector('head') : document.body;
	s.src = 'https://acsbap.com/apps/app/assets/js/acsb.js';
	s.async = s.defer = true;
	s.onload = function(){
	acsbJS.init({
	statementLink    : '',
	feedbackLink     : '',
	footerHtml       : '',
	hideMobile       : false,
	hideTrigger      : false,
	language         : 'en',
	position         : 'right',
	leadColor        : '#cf9f86',
	triggerColor     : '#cf9f86',
	triggerRadius    : '50%',
	triggerPositionX : 'right',
	triggerPositionY : 'top',
	triggerIcon      : 'default',
	triggerSize      : 'medium',
	triggerOffsetX   : 20,
	triggerOffsetY   : 20,
	mobile           : {
	triggerSize      : 'small',
	triggerPositionX : 'right',
	triggerPositionY : 'center',
	triggerOffsetX   : 0,
	triggerOffsetY   : 0,
	triggerRadius    : '50%'
	}
	});
	};
	e.appendChild(s);
	}());